import React from "react"

class SiteSwitcher extends React.Component {

  toggleOptions = () => {

    const switchBtn = document.querySelector("#switcher-chevron");
    const switchOpt = document.querySelector("#switcher-options");

    if ( switchBtn.classList.contains('switcher-chevron-flip') ) {
      // Hide
      switchBtn.classList.remove('switcher-chevron-flip');
      switchOpt.style.display = "none";
    } else {
      // Show
      switchBtn.classList.add('switcher-chevron-flip');
      switchOpt.style.display = "block";
    };

  };

  render() {

    const redirect = "https://www.kadenair.com.au?ref=" + Date.now();

    const switcher = ( 
      <>
        <style>
          {`
            #switcher-section {
              margin-top: 14px;
              padding: 0;
              display: block;
              cursor: pointer;
              color: #ffffff;
              width: 80px;
            }
            .switcher-selector {
              display: flex;
            }
            .switcher-selector-text {
              font-size: 0.9em;
              display: inline;
              padding: 0;
              margin: 0 3px 0 5px;
            }
            .switcher-icon {
              width: 24px;
              height: 24px;
            }
            .switcher-chevron-flip {
              transform: scaleY(-1);
            }

            #switcher-options {
              display:none;
            }
            .switcher-option {
              display: flex;
              background-color: #ffffff;
              margin-top: 4px;
              padding: 4px;
            }
            .switcher-option-text {
              font-size: 0.9em;
              display: inline;
              padding: 0;
              margin: 0 3px 0 5px;
              color: #004a60;
            }
            .switcher-option-arrow {
              color: #004a60;
              margin: auto 0 auto auto;
            }
          `}
        </style>

        <div id="switcher-section">
          
          <div className="uk-text-p-small uk-flex-middle switcher-selector" onClick={() => this.toggleOptions()}>
            <img
              src="/images/us-flag-round.svg"
              alt="American flag"
              className="uk-border-circle switcher-icon"
            />
            <span className="switcher-selector-text">USA</span>
            <span id="switcher-chevron" uk-icon="icon: chevron-down"></span>
          </div>

          <div id="switcher-options">
            <a href={redirect} className="uk-text-p-small uk-flex-middle uk-border-rounded switcher-option">
              <span className="switcher-option-text">AUS</span>
              <span className="switcher-option-arrow" uk-icon="icon: arrow-right"></span>
            </a>
          </div>
          

        </div>
      </>
    )
    return switcher
  }
}

export default SiteSwitcher
